import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { adjustedPx } from "../../utils/helpers";
export default class Slider {
    constructor(sliderContainer) {
        this.breakpoints = ['xs', 'sm', 'md', 'lg'];
        this.sliderContainer = sliderContainer;
        this.initSlider();
    }
    initSlidesPerView() {
        const self = this;
        const slidesPerBreakpoints = {};
        const slidesArray = [];
        const slidesPerViewData = self.sliderContainer.getAttribute('data-slides-per-view');
        if (slidesPerViewData) {
            const slidesPerView = slidesPerViewData.split(',');
            slidesPerView.forEach((slides, index) => {
                slidesArray.push(parseInt(slides));
            });
        }
        let prevSlidePerView = 1;
        self.breakpoints.forEach((breakpoint, index) => {
            const slidesPerView = slidesArray[index] ? slidesArray[index] : prevSlidePerView;
            slidesPerBreakpoints[breakpoint] = slidesPerView;
            prevSlidePerView = slidesPerView;
        });
        return slidesPerBreakpoints;
    }
    initSlider() {
        const self = this;
        const slidesPerBreakpoints = this.initSlidesPerView();
        const slider = self.sliderContainer.querySelector('.swiper');
        const navigationNextEl = self.sliderContainer.querySelector('.swiper-button-next');
        const navigationPrevEl = self.sliderContainer.querySelector('.swiper-button-prev');
        const paginationEl = self.sliderContainer.querySelector('.swiper-pagination');
        const loop = self.sliderContainer.hasAttribute('data-loop');
        const autoplay = self.sliderContainer.hasAttribute('data-autoplay');
        const sm = adjustedPx(576);
        const md = adjustedPx(744);
        const lg = adjustedPx(992);
        let options = {
            spaceBetween: 8,
            slidesPerView: slidesPerBreakpoints['xs'],
            loop: loop,
            autoplay: autoplay,
            modules: [],
            breakpoints: {
                [sm]: {
                    slidesPerView: slidesPerBreakpoints['sm'],
                    spaceBetween: 16
                },
                [md]: {
                    slidesPerView: slidesPerBreakpoints['md'],
                    spaceBetween: 24
                },
                [lg]: {
                    slidesPerView: slidesPerBreakpoints['lg'],
                    spaceBetween: 24
                }
            }
        };
        if (autoplay) {
            options.modules.push(Autoplay);
        }
        if (navigationNextEl && navigationPrevEl) {
            options.modules.push(Navigation);
            options["navigation"] = {
                nextEl: navigationNextEl,
                prevEl: navigationPrevEl
            };
        }
        if (paginationEl) {
            options.modules.push(Pagination);
            options["pagination"] = {
                el: paginationEl,
                clickable: true
            };
        }
        new Swiper(slider, options);
    }
}
